import type { FC } from 'react';

import type { IconProps } from './type';

export const WebcoinFilledIcon: FC<IconProps> = ({ ...props }) => {
  return (
    <svg
      data-id="webcoin-filled-icon"
      fill="none"
      height={23}
      width={23}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.239 22.163c-1.516 0-2.947-.286-4.293-.858a11.516 11.516 0 0 1-3.493-2.366 10.867 10.867 0 0 1-2.356-3.501A10.674 10.674 0 0 1 .24 11.17c0-1.515.286-2.945.858-4.29a11.073 11.073 0 0 1 2.356-3.49 11.082 11.082 0 0 1 3.493-2.354 10.862 10.862 0 0 1 4.293-.858c1.516 0 2.94.286 4.27.858a10.875 10.875 0 0 1 3.504 2.354c.99.997 1.78 2.16 2.367 3.49a10.84 10.84 0 0 1 .859 4.29c0 1.515-.286 2.937-.859 4.267a11.282 11.282 0 0 1-2.367 3.501c-.99.99-2.158 1.778-3.504 2.366-1.33.572-2.754.858-4.27.858Zm1.253-6.424h1.856l2.878-8.603H14.86l-1.462 4.406-1.253-4.406h-1.81L9.08 11.542 7.619 7.136H5.25l2.878 8.603h1.857l1.253-4.15 1.253 4.15Z"
        fill="#00BAFF"
      />
    </svg>
  );
};
